<template>
    <div class="md-content">
        <md-toolbar md-elevation="1">
            <label v-if="current">{{current.firstName}} {{current.lastName}}</label>
            <div class="md-toolbar-section-end">
                <md-button @click="deleteConfirmation" :disabled="current == null" class="md-raised md-primary ">
                    <md-icon>delete</md-icon>
                </md-button>
                <md-button @click="addReset(true)" class="md-raised md-primary">
                    <md-icon>add</md-icon>
                </md-button>
            </div>
        </md-toolbar>
        <div :disabled="current == null">
            <md-table v-if="items" v-model="items" @md-selected="onSelect">
                <!-- md-has-selection md-selected-single -->
                <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                    <md-table-cell md-label="Prénom">{{ item.firstName }}</md-table-cell>
                    <md-table-cell md-label="Nom">{{ item.lastName }}</md-table-cell>
                </md-table-row>
            </md-table>
        </div>

        <div v-if="isAdd" class="md-my-3 md-layout md-alignment-center-center">
            <div class="md-layout-item ">
                <md-autocomplete v-model="autocompleteSelected" :md-options="autocompleteUsersDataSource" @md-selected="onAutocompleteSelect" :md-open-on-focus="false" ref='acNewUser'>
                    <label>Usager</label>
                </md-autocomplete>
            </div>
            <div class="md-layout-item">
                <md-button v-on:click="addConfirm" class="md-raised md-primary">Ok</md-button>
                <md-button v-on:click="addReset(false)" class="md-raised md-primary">Cancel</md-button>
            </div>
        </div>

        <md-dialog-confirm :md-active.sync="isDelete"
                           md-title="Attention"
                           md-content="Voulez-vous vraiment retirer cet usager de ce rôle ?"
                           md-confirm-text="Oui"
                           md-cancel-text="Non"
                           @md-confirm="deleteConfirm" />
    </div>

</template>
<style scoped>
    .md-table-row.md-selected,
    .md-table-row.md-selected-single {
        background-color: var(--md-theme-default-primary) !important;
    }

    .md-toolbar.md-theme-default {
        color: var(--md-theme-default-primary) !important;
    }
</style>

<script>
    import { apiSecurityExtension } from '@/mixins/apiSecurityExtension.js';
    import { autocompleteExtension } from '@/mixins/autocompleteExtension.js'


    export default {
        name: 'role-user',
        mixins: [apiSecurityExtension, autocompleteExtension],
        props: ['items'],
        data: () => ({
            current: null,
            users: null,
            autocompleteUsersDataSource: null,
            autocompleteSelected: null,
            isAdd: false,
            isDelete: false,
        }),
        computed: {},
        mounted:
            function () {
                this.usersRead();
                this.dataRead();
            },
        methods: {
            dataRead: async function () {

                let data = await this.SecurityRoleUserListById(this.$route.params.id);
                if (data) {
                    this.$emit("update:items", data);
                } else {
                    this.$emit("update:items", []); 
                }
            },
            usersRead: async function () {

                let data = await this.SecurityUserList();
                if (data) {
                    this.users = data;
                    this.autocompleteUsersDataSource = this.autocompleteDataSource(data, function (ref) { return ref.firstName + ' ' + ref.lastName; });
                }
            },

            onSelect: function (item) {
                this.addReset(false);
                this.current = item;
            },
            onAutocompleteSelect: function (item) {
                this.current = item.ref
            },

            addConfirm: function () {
                for (let i = 0; i < this.users.length; i++) {
                    if (this.users[i].id === this.current.id
                        && this.items.findIndex(x => x.id === this.current.id) === -1) {
                        this.items.push(this.users[i]);
                        this.current = null;
                        break;
                    }
                }
                this.isAdd = false;
            },
            addReset: function (value) {
                this.current = null;
                this.autocompleteSelected = null;
                this.isAdd = value;
                if (this.isAdd === true) {
                    this.$nextTick(() => {
                        // this.$refs.acNewUser.$el.focus();
                        this.$refs.acNewUser.$el.querySelector('input').focus();
                    });
                }
            },
            deleteConfirmation: function () {
                this.isDelete = true;
            },
            deleteConfirm: function () {
                for (let i = 0; i < this.items.length; i++) {
                    if (this.items[i].id === this.current.id) {
                        this.items.splice(i, 1);
                    }
                }

            },
        },

        components: {}
    };
</script>